// src/RuTubeModal.jsx
import React from 'react';
import { X } from 'lucide-react';

const RuTubeModal = ({ open, videoUrl, onClose }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
      <div className="bg-white w-full h-[90vh] max-w-6xl rounded-xl shadow-2xl overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <div className="font-semibold text-gray-800 truncate">Видео</div>
          <div className="flex items-center gap-2">
            <a href={videoUrl} target="_blank" rel="noopener noreferrer" className="text-sm px-3 py-1.5 rounded bg-blue-600 text-white hover:bg-blue-700">
              Открыть на RuTube
            </a>
            <button onClick={onClose} className="p-2 rounded hover:bg-gray-100 text-gray-600" aria-label="Закрыть">
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="flex-1 bg-black">
          <iframe
            title="RuTube"
            src={videoUrl}
            className="w-full h-full"
            allow="autoplay; fullscreen; picture-in-picture"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
};

export default RuTubeModal;


